<template>
  <header :class="{ 'mobile-header': screenWidth < 835, 'lh-navbar': screenWidth > 835 }">
    <div class="lh-navbar__logo">
      <img alt="logo" src="../assets/images/header-logo.png" @click="redirectToHomePage" />
    </div>
    <img
      v-if="screenWidth < 835"
      src="@/assets/images/mobile-menu.svg"
      alt="mobile-menu"
      class="mobile-menu-img"
      @click="showHideMenu" />
    <nav
      v-if="authManager.loggedIn"
      class="lh-navbar__menu"
      :class="{ 'mobile-menu': screenWidth < 835, hide: mobileMenu }">
      <ul class="lh-navbar__list">
        <li class="lh-navbar__item">1-510-598-7013</li>
        <li class="lh-navbar__item">
          <router-link :to="{ name: 'all-patients' }" class="lh-navbar__link"> Patients </router-link>
        </li>
        <!-- <li class="lh-navbar__item">
          <router-link :to="{ name: 'insurance-navigator-page' }" class="lh-navbar__link">
            Start New Submission
          </router-link>
        </li> -->
        <li class="lh-navbar__item">
          <router-link :to="{ name: 'all-submissions' }" class="lh-navbar__link">All Submissions</router-link>
        </li>
        <li v-if="cmmIntakeEnabled" class="lh-navbar__item">
          <router-link :to="{ name: 'import-cmm-submission' }" class="lh-navbar__link"
            >Import CMM Submission</router-link
          >
        </li>
        <li class="lh-navbar__item lh-button--small-condensed-snow lh-navbar__logout">
          <router-link :to="{ name: 'login' }" class="lh-navbar__link" @click="logoutUser">Log Out</router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
import { useAuthStore, useRequirementsStore } from "@/stores";

const screenWidth = ref(null);
const mobileMenu = ref(true);

const authManager = useAuthStore();
const requirementsStore = useRequirementsStore();

const cmmIntakeEnabled = computed(() => {
  return requirementsStore.clientConfig?.priorAuth?.cmmIntakeEnabled ?? false;
});

onMounted(async () => {
  if (!requirementsStore.clientConfig) {
    await requirementsStore.refreshCurrentUserClientConfig();
  }
});

function displayWindowSize() {
  screenWidth.value = document.documentElement.clientWidth;
}

window.addEventListener("resize", displayWindowSize);

displayWindowSize();

function showHideMenu() {
  mobileMenu.value = mobileMenu.value ? false : true;
}

function redirectToHomePage() {
  router.push({ name: "all-submissions" });
}

async function logoutUser() {
  await authManager.logout();
  window.location.reload();
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_prior-header.scss";
</style>
